export default __webpack_public_path__ + "static/media/s0_female.40c228b7.wav";